const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'ymail.com',
  'rocketmail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'pm.me',
  'gmx.com',
  'gmx.net',
  'mail.com',
])

export function isPersonalEmailProvider(email: string): boolean {
  const separator = email.lastIndexOf('@')
  if (separator < 0) return false

  return PERSONAL_EMAIL_DOMAINS.has(email.slice(separator + 1).trim().toLowerCase())
}
